import i18n, { i18n as I18NType } from "i18next";
import Backend from "i18next-chained-backend";
import { getDomain } from "../utils/stringUtils";
import ContentApiBackend from "./ContentApiBackend";
import labels from "./labels.json";
import lpLabels from "./lpLabels.json";

const createI18N = (i18n: I18NType) => (languageCode: string) => {
  const contentApiBackendOptions = {
    apiKey: process.env.REACT_APP_CONTENT_API_KEY,
    apiUrl: process.env.REACT_APP_CONTENT_API,
    labels: [...labels, ...lpLabels],
  };
  const namespace = getDomain();

  const instance = i18n.createInstance();

  instance.use(Backend).init({
    backend: {
      backends: [ContentApiBackend],
      backendOptions: [contentApiBackendOptions],
    },
    defaultNS: namespace,
    ns: namespace,
    interpolation: {
      escapeValue: false, // react already safes from xss
      prefix: "${",
      suffix: "}",
    },
    keySeparator: false, // we do not use keys in form messages.welcome
    lng: languageCode,
    fallbackLng: languageCode,
    initImmediate: false,
    react: {
      useSuspense: true,
      wait: true,
    },
    saveMissing: true,
  });

  return instance;
};

export default createI18N(i18n);
